<template>
    <div class="footer-section">
        <div class="footer-container">
            <section class="footer-info">
                <div class="footer-brand fuente-posm">Proactive</div>

                <p class="footer-description fuente-nova">
                    Instalaciones que conectan tecnología con cada espacio.
                    Del sureste de México al país entero.
                </p>

                <div class="footer-links">
                    <a href="https://proactive.lat" target="_blank" class="fuente-nova">proactive.lat</a>
                    <a href="mailto:hola@proactive.lat" class="fuente-nova">hola@proactive.lat</a>
                    <a href="tel:+529999306053" target="_blank" class="fuente-nova">+52 (999) 930.60.53</a>
                </div>

                <div class="footer-social">
                    <a href="https://www.facebook.com/proactivelat" target="_blank">Facebook</a>
                    <a href="https://www.instagram.com/proactivelat/" target="_blank">Instagram</a>
                    <a href="https://wa.me/529999306053" target="_blank">WhatsApp</a>
                </div>

                <p class="footer-address fuente-nova">
                    Mérida, Yucatán, México
                </p>
            </section>

            <section class="footer-nav">
                <div class="footer-nav-group">
                    <h3 class="fuente-nova2">Especialidades</h3>
                    <router-link to="/audio" class="fuente-nova">Audio</router-link>
                    <router-link to="/video" class="fuente-nova">Video</router-link>
                    <router-link to="/datos" class="fuente-nova">Datos</router-link>
                    <router-link to="/domotica" class="fuente-nova">Domótica</router-link>
                </div>
                <div class="footer-nav-group">
                    <h3 class="fuente-nova2">Contacto</h3>
                    <a href="tel:+529999306053" class="fuente-nova">+52 (999) 930.60.53</a>
                    <a href="mailto:hola@proactive.lat" class="fuente-nova">hola@proactive.lat</a>
                    <a href="https://maps.app.goo.gl/ucEpt5utRkaAQeBm9" target="_blank" rel="noopener noreferrer" class="fuente-nova">Dirección</a>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
export default {
    name: 'FooterProactive',
    data() {
        return {}
    }
}
</script>

<style lang="css" scoped>
.footer-section {
    width: 100vw;
    min-height: 100vh;
    background-color: #1a1a1a;
    scroll-snap-align: start;
    box-sizing: border-box;
}

.footer-container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    max-width: 1200px;
    margin: 0 auto;
    padding: 80px 40px;
    gap: 60px;
}

.footer-info {
    max-width: 340px;
    color: white;
}

.footer-brand {
    font-size: 36px;
    font-weight: 700;
    color: white;
    letter-spacing: -1px;
    margin-bottom: 20px;
}

.footer-description {
    font-size: 15px;
    line-height: 1.7;
    color: rgba(255, 255, 255, 0.75);
    margin: 0 0 24px 0;
}

.footer-links {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-bottom: 24px;
}

.footer-links a {
    color: rgba(255, 255, 255, 0.65);
    font-size: 13px;
    font-weight: 500;
    text-decoration: none;
    transition: color 0.2s ease;
}

.footer-links a:hover {
    color: white;
}

.footer-social {
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-bottom: 24px;
}

.footer-social a {
    color: white;
    font-weight: 500;
    text-decoration: none;
    font-size: 15px;
    display: flex;
    align-items: center;
    gap: 10px;
    transition: opacity 0.2s ease;
}

.footer-social a:hover {
    opacity: 0.7;
}

.footer-social img {
    width: 18px;
    height: 18px;
}

.footer-address {
    font-size: 12px;
    color: rgba(255, 255, 255, 0.45);
    margin: 0;
}

.footer-nav {
    display: flex;
    gap: 60px;
    padding-top: 10px;
}

.footer-nav-group {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.footer-nav-group h3 {
    font-size: 13px;
    font-weight: 700;
    color: white;
    text-transform: uppercase;
    letter-spacing: 0.08em;
    margin: 0 0 4px 0;
}

.footer-nav-group a {
    color: rgba(255, 255, 255, 0.65);
    font-size: 14px;
    text-decoration: none;
    transition: color 0.2s ease;
}

.footer-nav-group a:hover {
    color: white;
}

@media (max-width: 768px) {
    .footer-section {
        min-height: auto;
    }

    .footer-container {
        flex-direction: column;
        padding: 50px 24px;
        gap: 40px;
    }

    .footer-info {
        max-width: 100%;
    }

    .footer-nav {
        gap: 40px;
    }
}
</style>
